import { neg } from "@thi.ng/vectors";
import { concat } from "./concat";
import { scale23, scale44 } from "./scale";
import { translation23, translation44 } from "./translation";
/**
 * Computes a 2x3 matrix representing a scale operation with origin `p`
 * and writes result to `out`.
 *
 * @param out -
 * @param m -
 */
export const scaleWithCenter23 = (m, p, s) => concat(m, translation23([], p), scale23([], s), translation23([], neg([], p)));
/**
 * Computes a 4x4 matrix representing a scale operation with origin `p`
 * and writes result to `out`.
 *
 * @param out -
 * @param m -
 */
export const scaleWithCenter44 = (m, p, s) => concat(m, translation44([], p), scale44([], s), translation44([], neg([], p)));
